import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Actions as EMPLOYEEACTIONS } from "../../store/actions/employeeActions";
import { Actions as ACTIONS } from "../../store/actions/timesheetActions";
import { Actions as WORK_LOCATION_ACTIONS } from "../../store/actions/workLocationActions";
import Select from "react-select";
import { Actions as PERMISSIONACTIONS } from "../../store/actions/permissionActions";
import DatePicker from "react-datepicker";
import { DateInputFormat } from "../common/DateComponents";
import {
	add,
	addMonths,
	addYears,
	differenceInDays,
	endOfMonth,
	format,
	intervalToDuration,
	set,
	sub,
	subYears,
} from "date-fns";
import { MagnifyingGlassIcon, PrinterIcon } from "@heroicons/react/20/solid";
import { useMemo } from "react";
import ReactToPrint from "react-to-print";
import Spinner from "../common/Spinner";
import ArchivedCompany from "../company-pages/ArchivedCompany";
import InvalidPermissions from "../company-pages/InvalidPermissions";
import EmployeeTimesheet from "./EmployeeTimesheet";
import { employmentTypeOptions } from "../company-settings/config/employmentTypeOptions";

const statusOptions = [
	{ label: "Approved", value: "Approved" },
	{ label: "Pending", value: "Pending" },
	{ label: "Requires Review", value: "Incomplete" },
	{ label: "Deleted", value: "deleted" },
];

const TimesheetTable = ({
	org,
	employeesGetList,
	departmentOptions,
	timesheetGet,
	employeeOptions,
	workLocationOptions,
	employeesGetListWithSalary,
	getWorkLocationSettings,
	timesheets,
	processing,
	userPermissions,
	getMyPermissions,
	archivedStatus,
	jurisdiction,
	hasDepartments,
	location,
	employeeId,
}) => {
	const [selectedDepartment, setSelectedDepartment] = useState();
	const [selectedEmployee, setSelectedEmployee] = useState((employeeId.value && employeeId) || null);
	const [selectedEmploymentType, setSelectedEmploymentType] = useState();
	const [selectedWorkLocation, setSelectedWorkLocation] = useState();
	const [selectedStatus, setSelectedStatus] = useState();
	// const today = set(new Date(), { month: 1, date: 17 });
	const today = set(new Date(), { milliseconds: 0, seconds: 0, minutes: 0, hours: 0 });

	const [startDate, setStartDate] = useState(() => {
		let firstDayOfMonth;
		switch (jurisdiction) {
			case "UK":
				let monthToAdd = -1;
				if (today.getDate() > 5) monthToAdd = 0;
				firstDayOfMonth = set(today, { month: today.getMonth() + monthToAdd, date: 6 });
				break;
			case "MT":
			default:
				firstDayOfMonth = new Date(today.getFullYear(), 1, 1);
				break;
		}

		return new Date(firstDayOfMonth.getTime() - firstDayOfMonth.getTimezoneOffset() * 60000);
	});
	const [endDate, setEndDate] = useState(() => {
		let lastDayOfMonth;
		switch (jurisdiction) {
			case "UK":
				let monthToAdd = 1;
				if (today.getDate() < 6) monthToAdd = 0;
				lastDayOfMonth = set(today, { month: today.getMonth() + monthToAdd, date: 5 });
				break;
			case "MT":
			default:
				lastDayOfMonth = endOfMonth(today);
				break;
		}

		return new Date(lastDayOfMonth.getTime() - lastDayOfMonth.getTimezoneOffset() * 60000);
	});

	const [loaded, setLoaded] = useState(false);
	// const [filteredTimesheets, setFilteredTimesheets] = useState(null);

	const updateTimesheets = () => {
		const from =
			startDate &&
			new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000).toISOString().substring(0, 10);
		const to =
			endDate && new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000).toISOString().substring(0, 10);

		timesheetGet({
			from,
			to,
			department: selectedDepartment?.value,
			agreement: selectedEmployee?.value,
			status: selectedStatus?.value,
			workLocation: selectedWorkLocation?.value,
			employmentType: selectedEmploymentType?.value,
		});
	};

	useEffect(() => {
		if (location == "timesheetPage") return;
		updateTimesheets();
	}, [selectedDepartment, selectedEmployee, selectedEmploymentType, selectedWorkLocation, selectedStatus]);

	useEffect(() => {
		if (!loaded) {
			if (!employeeOptions?.length)
				employeesGetListWithSalary({
					from: format(addMonths(new Date(), -1), "yyyy-MM-01"),
					to: format(addMonths(new Date(), 3), "yyyy-MM-31"),
				});
			employeesGetList();
			getMyPermissions();
			if (!workLocationOptions?.length) getWorkLocationSettings();
			const urlParams = new URLSearchParams(window.location.search);
			const fromParam = urlParams.get("from");
			const toParam = urlParams.get("to");
			if (fromParam && toParam) {
				setStartDate(new Date(fromParam));
				setEndDate(new Date(toParam));
			}
		}
	}, [org, loaded]);

	useEffect(() => {
		setLoaded(!!employeeOptions);
	}, [employeeOptions?.length, workLocationOptions?.length]);

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const agreementParam = urlParams.get("agreement");
		const workLocationParam = urlParams.get("workLocation");
		console.log(employeeOptions);
		if (employeeOptions && agreementParam && !selectedEmployee) {
			setSelectedEmployee(employeeOptions?.find((e) => e.value === String(agreementParam)));
		}
		if (workLocationOptions && workLocationParam && !selectedWorkLocation) {
			setSelectedWorkLocation(workLocationOptions.find((l) => l.value == workLocationParam));
		}
	}, [employeeOptions?.length, workLocationOptions?.length]);

	const timesheetTableRef = React.createRef();

	const employmentTypeFilter = useMemo(() => {
		if (selectedEmploymentType?.value) {
			switch (selectedEmploymentType.value) {
				case "Full-time":
					employmentTypeFilter = "show-employmentType-FT";
					break;
				case "Part-time":
					employmentTypeFilter = "show-employmentType-PT";
					break;
				default:
					break;
			}
		}
	}, [selectedEmploymentType?.value]);

	if (archivedStatus == "Archived") return <ArchivedCompany />;
	if (userPermissions == "None") return <InvalidPermissions />;

	return (
		<div className="content">
			<div className="form-group">
				<div
					className="col-sm-3 col-xs-4"
					style={{ maxHeight: "65px" }}
				>
					<label>From</label>
					<DatePicker
						selected={startDate}
						wrapperClassName="full-width"
						onChange={(date) => {
							if (!date) return;
							if (differenceInDays(endDate, date) <= 0) {
								const interval = intervalToDuration({
									start: startDate,
									end: endDate,
								});
								const newEndDate = add(date, interval);
								setEndDate(newEndDate);
							}
							setStartDate(date);
						}}
						showYearDropdown
						minDate={subYears(new Date(), 100)}
						maxDate={addYears(new Date(), 20)}
						dateFormat="dd/MM/yyyy"
						customInput={<DateInputFormat />}
					/>
				</div>
				<div
					className="col-sm-3 col-xs-4"
					style={{ maxHeight: "65px" }}
				>
					<label htmlFor=" ">To</label>
					<DatePicker
						wrapperClassName="full-width"
						selected={endDate}
						onChange={(date) => {
							if (!date) return;
							if (differenceInDays(date, startDate) < 0) {
								const interval = intervalToDuration({
									start: endDate,
									end: startDate,
								});
								const newStartDate = sub(date, interval);
								setStartDate(newStartDate);
							}
							setEndDate(date);
						}}
						showYearDropdown
						maxDate={addYears(new Date(), 20)}
						dateFormat="dd/MM/yyyy"
						customInput={<DateInputFormat />}
					/>
				</div>
				{hasDepartments ? (
					<div
						className="col-sm-3 col-xs-4"
						style={{ minHeight: "65px" }}
					>
						<label htmlFor=" ">Department</label>
						<Select
							options={departmentOptions}
							value={selectedDepartment}
							onChange={setSelectedDepartment}
							isClearable
						/>
					</div>
				) : null}
				<div
					className="col-sm-3 col-xs-4"
					style={{ minHeight: "65px" }}
				>
					<label htmlFor=" ">Status</label>
					<Select
						options={statusOptions}
						value={selectedStatus}
						onChange={setSelectedStatus}
						isClearable
					/>
				</div>
				<div
					className="col-sm-3 col-xs-4"
					style={{ minHeight: "65px" }}
				>
					<label htmlFor="">Work Location</label>
					<Select
						options={workLocationOptions}
						value={selectedWorkLocation}
						onChange={setSelectedWorkLocation}
						isClearable
					/>
				</div>
				<div
					className="mt-5"
					style={{
						display: `${location == "timesheetPage" ? "" : "none"}`,
					}}
				>
					<div
						className="col-sm-3 col-xs-4"
						style={{ minHeight: "65px" }}
					>
						<label for=" ">Employee</label>
						<Select
							options={employeeOptions}
							value={selectedEmployee}
							onChange={setSelectedEmployee}
							isClearable
						/>
					</div>
					<div
						className="col-sm-3 col-xs-4"
						style={{ minHeight: "65px" }}
					>
						<label htmlFor=" ">Employment Type</label>
						<Select
							options={employmentTypeOptions}
							value={selectedEmploymentType}
							onChange={setSelectedEmploymentType}
							isClearable
						/>
					</div>
					<div className="col-sm-3 col-xs-4 pull-right">
						<div className="h-[65px] flex flex-row-reverse items-end gap-x-4">
							<button
								type="button"
								disabled={processing}
								className="btn btn-success"
								onClick={updateTimesheets}
							>
								{processing ? (
									<Spinner className="animate-spin mr-2 h-8 w-8 align-top" />
								) : (
									<MagnifyingGlassIcon className="h-8 w-8 align-text-top mr-2" />
								)}
								View Timesheets
							</button>

							<ReactToPrint
								trigger={() => (
									<button
										type="button"
										disabled={!timesheets?.length || processing}
										className="btn btn-default"
										title="Print Report"
									>
										<PrinterIcon className="h-8 w-8 align-text-top" />
									</button>
								)}
								content={() => timesheetTableRef.current}
								pageStyle=".table > tbody > tr > td{ padding: 0 10px !important;}i{display:none;}a{display:none;}"
							/>
						</div>
						<div className="clearfix" />
					</div>
				</div>

				<div className="clearfix" />
			</div>
			<div className="clearfix" />

			<div className="table-responsive">
				<table
					className="js-table-sections table table-hover"
					ref={timesheetTableRef}
				>
					<thead>
						<tr>
							<th width="5%"></th>
							{location == "timesheetPage" && <th>Employee</th>}
							<th width="10%">Date</th>
							<th>Hours Worked</th>
							<th>Time in</th>
							<th>Time out</th>
							<th>Location</th>
							<th>Break</th>
							<th width="15%"></th>
						</tr>
					</thead>
					<tbody className={employmentTypeFilter}>
						{!processing &&
							timesheets?.map((employee) => (
								<EmployeeTimesheet
									key={employee.employeeId}
									salary={employeeOptions?.find((e) => e.value === employee.agreement)?.salary}
									employeeTimesheet={employee}
									location={location}
								/>
							))}
					</tbody>
				</table>
			</div>
			<div className="clearfix" />
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const employeeOptions = state?.employees?.employeeListWithSalary?.map((employee) => ({
		value: employee.id,
		label: `${employee.employeeName} ${employee.employeeSurname}`,
		salary: employee.salaries[employee.salaries.length - 1],
	}));
	const workLocationOptions = state?.workLocation?.types?.map((loc) => ({
		value: loc.id,
		label: loc.name,
	}));
	const userPermissions = state?.permissions?.my?.permissions?.timesheets;
	const settingsPermissions = state?.permissions?.my?.permissions?.settings;
	const { enableDepartments, departments } = state?.company?.settings;

	const employeeId = state?.employee?.employeeDetails?.id;

	return {
		org: state?.company?.settings?.org,
		...state.timesheets,
		employeeOptions,
		workLocationOptions,
		settingsPermissions,
		departmentOptions: departments?.map((department) => ({
			label: department.departmentName || department.name,
			value: department.id,
		})),
		hasDepartments: enableDepartments === undefined ? !!departments?.length : enableDepartments,
		userPermissions,
		jurisdiction: state?.company?.settings?.jurisdiction,
		archivedStatus: state?.company?.settings?.status,
		employeeId: { value: employeeId },
		location: ownProps.location,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getWorkLocationSettings: () => dispatch(WORK_LOCATION_ACTIONS.getWorkLocationSettings()),
	getMyPermissions: () => dispatch(PERMISSIONACTIONS.getMyPermissions()),
	employeesGetList: () => dispatch(EMPLOYEEACTIONS.employeesGetList()),
	timesheetGet: (params) => dispatch(ACTIONS.timesheetGet(params)),
	getWorkLocationSettings: () => dispatch(WORK_LOCATION_ACTIONS.getWorkLocationSettings()),
	employeesGetListWithSalary: ({ from, to }) => dispatch(EMPLOYEEACTIONS.employeesGetListWithSalary({ from, to })),
});

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetTable);
